import { ClassMaster } from '../models/class-master';
import { Location } from '../models/location';

export class ClassScheduleDto {
  constructor() {
    this.id = '';
    this.startDateTime = '';
    this.startTime = '';
    this.active = true;
    this.studentCount = 0;
    this.classMaster = new ClassMaster();
    this.location = new Location();
  }

  id: string;
  startDateTime: string;
  startTime: string;
  active: boolean;
  studentCount: number;
  classMaster: ClassMaster;
  location: Location;
}



// WEBPACK FOOTER //
// ./src/app/models/class-schedule-dto.ts